import { InjectableService } from "@/shared/services/InjectableService";

export type SchemaVersion = `${number}.${number}.${number}`;

export abstract class SchemaVersionedService<TVersion extends SchemaVersion = SchemaVersion> extends InjectableService {

    protected readonly version: TVersion;

    protected constructor(version: TVersion) {
        
        super();
        
        if (!SchemaVersionedService.isSchemaVersion(version as unknown as string)) {
            throw new Error(`Invalid schema version: ${String(version)}`);
        }

        this.version = version;
    }


    public static isSchemaVersion(value: string): value is SchemaVersion {
        return /^\d+\.\d+\.\d+$/.test(value);
    }

}